<ng-container [ngSwitch]="state">
  <ng-container *ngSwitchCase="ViewLoadState.FETCHING">
    <ng-container *ngIf="fetchingTemplate; else defaultFetchingTemplate">
      <ng-container *ngTemplateOutlet="fetchingTemplate"></ng-container>
    </ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="ViewLoadState.FETCHED">
    <ng-container *ngTemplateOutlet="fetchedTemplate"></ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="ViewLoadState.ERROR">
    <ng-container *ngIf="errorTemplate; else defaultErrorTemplate">
      <ng-container *ngTemplateOutlet="errorTemplate"></ng-container>
    </ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="ViewLoadState.NO_DATA">
    <ng-container *ngIf="unavailableTemplate; else defaultUnavailableTemplate">
      <ng-container *ngTemplateOutlet="unavailableTemplate"></ng-container>
    </ng-container>
  </ng-container>

  <ng-container *ngSwitchDefault>
    <ng-container *ngTemplateOutlet="defaultUnavailableTemplate"></ng-container>
  </ng-container>
</ng-container>

<ng-template #defaultFetchingTemplate>
  <ng-container i18n="@@Loading...">Loading...</ng-container>
</ng-template>

<ng-template #defaultUnavailableTemplate>
  <span class="unavailable"
        i18n="@@Unavailable">Unavailable</span>
</ng-template>

<ng-template #defaultErrorTemplate>
  <span class="error"
        i18n="@@Error_during_fetching">Error during fetching</span>
</ng-template>